import { adminHttpClient } from '../../../commons/adminHttpClient'

import OrderedPageFilter from '../../../commons/orderedPageFilter'
import PagedList from '../../../commons/PagedList'

export interface PagedOverReimbursements extends PagedList<OverReimbursementItem> {}

export interface OverReimbursementItem {
  companyUserId: string
  fullName: string
  allowanceYTD: number
  expenseYTD: number
  reimbursementYTD: number
  overReimbursed: number
}

const getOverReimbursements = (filter: OrderedPageFilter, planPeriodId: string): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'fullName',
    orderDescending: true,
  }
  return adminHttpClient.get(`/AdminDashboard/OverReimbursements/${planPeriodId}`, filter)
}

export default getOverReimbursements
